import React from 'react';
import Date from '../utils/Date';

const LogDate = ({ value }) => (
  <Date format="d 'de' MMMM, h:mm aaaa" value={value} />
);

export default LogDate;
